// extracted by mini-css-extract-plugin
module.exports = {"single_header":"ContentPage_single_header__2uAFg","single_nav":"ContentPage_single_nav__3_WYX","active":"ContentPage_active__ysfYn","file":"ContentPage_file__3vPeA"};